// mediaControls.js
import { clamp, formatTime } from '../utils';

export function mountMediaControls({ root = document, onAnyMediaPlay } = {}) {
  function pauseAllMediaExcept(exceptEl) {
    root.querySelectorAll('audio, video').forEach((m) => {
      if (m === exceptEl) return;
      if (!m.paused) m.pause();
    });

    root
      .querySelectorAll('[data-action="toggle-audio"].play')
      .forEach((btn) => {
        btn.classList.remove('play');
        btn.setAttribute('aria-pressed', 'false');
      });
  }

  // 플레이 감지
  const onMediaPlay = (e) => {
    const media = e.target;
    if (!media || !root.contains(media)) return;

    if (media.tagName === 'VIDEO' || media.tagName === 'AUDIO') {
      pauseAllMediaExcept(media);
      onAnyMediaPlay?.();
    }
  };

  // 오디오 토글
  const onAudioToggle = (e) => {
    const btn = e.target.closest('[data-action="toggle-audio"]');
    if (!btn || !root.contains(btn)) return;

    e.preventDefault();
    e.stopPropagation();

    const wrap = btn.closest('.story-meta_body');
    const audio = wrap?.querySelector('.audio_el');
    if (!audio) return;

    if (audio.paused) {
      pauseAllMediaExcept(audio);
      onAnyMediaPlay?.();

      audio.play().catch(() => {});
      btn.setAttribute('aria-pressed', 'true');
      btn.classList.add('play');
    } else {
      audio.pause();
      btn.setAttribute('aria-pressed', 'false');
      btn.classList.remove('play');
    }
  };

  // 오디오 seek
  const onAudioSeek = (e) => {
    if (e.target.closest('[data-action="toggle-audio"]')) return;

    const bar = e.target.closest('[data-action="seek"]');
    if (!bar || !root.contains(bar)) return;

    const wrap = bar.closest('.story-meta_body');
    const audio = wrap?.querySelector('.audio_el');
    if (!audio || !audio.duration) return;

    const rect = bar.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const t = clamp(x / rect.width, 0, 1);
    audio.currentTime = audio.duration * t;
  };

  // 오디오 메타/시간 업데이트
  const onLoadedMeta = (e) => {
    const audio = e.target;
    if (!audio?.classList?.contains('audio_el')) return;
    if (!root.contains(audio)) return;

    const wrap = audio.closest('.story-meta_body');
    const totalEl = wrap?.querySelector('.audio_total');
    if (totalEl) totalEl.textContent = formatTime(audio.duration);
  };

  const onTimeUpdate = (e) => {
    const audio = e.target;
    if (!audio?.classList?.contains('audio_el')) return;
    if (!root.contains(audio)) return;

    const wrap = audio.closest('.story-meta_body');
    if (!wrap) return;

    const currentEl = wrap.querySelector('.audio_current');
    const marker = wrap.querySelector('.audio_marker');

    if (currentEl) currentEl.textContent = formatTime(audio.currentTime);

    if (marker && audio.duration) {
      const bar = marker.closest('[data-action="seek"]');
      if (!bar) return;

      const barRect = bar.getBoundingClientRect();
      const markerRect = marker.getBoundingClientRect();

      const maxX = barRect.width - markerRect.width;
      const t = audio.currentTime / audio.duration;

      const x = clamp(t * maxX, 0, maxX);
      marker.style.left = `${x}px`;
    }
  };

  const onAudioEnded = (e) => {
    const audio = e.target;
    if (!audio?.classList?.contains('audio_el')) return;
    if (!root.contains(audio)) return;

    const wrap = audio.closest('.story-meta_body');
    const btn = wrap?.querySelector('[data-action="toggle-audio"]');
    if (!btn) return;

    btn.setAttribute('aria-pressed', 'false');
    btn.classList.remove('play');
  };

  root.addEventListener('play', onMediaPlay, true);

  root.addEventListener('click', onAudioToggle, true);
  root.addEventListener('click', onAudioSeek, true);

  root.addEventListener('loadedmetadata', onLoadedMeta, true);
  root.addEventListener('timeupdate', onTimeUpdate, true);
  root.addEventListener('ended', onAudioEnded, true);

  function destroy() {
    root.removeEventListener('play', onMediaPlay, true);

    root.removeEventListener('click', onAudioToggle, true);
    root.removeEventListener('click', onAudioSeek, true);

    root.removeEventListener('loadedmetadata', onLoadedMeta, true);
    root.removeEventListener('timeupdate', onTimeUpdate, true);
    root.removeEventListener('ended', onAudioEnded, true);
  }

  return { destroy };
}
